import Carousel from "react-multi-carousel";
import { Suspense } from "react";
import "react-multi-carousel/lib/styles.css";

const ImageSliders = ({ images }) => {

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  const ButtonGroup = ({ next, previous, carouselState }) => {
    const { currentSlide, slidesToShow, totalItems } = carouselState;

    return (
      <div className="absolute inset-0 flex justify-between items-center px-4 z-10">
        {/* Left Arrow */}
        <button
          onClick={previous}
          className={`w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition `} //${currentSlide === 0 ? "opacity-40 cursor-not-allowed" : ""}`
        >
          ❮
        </button>

        {/* Right Arrow */}
        <button
          onClick={next}
          className={`w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition ${currentSlide + slidesToShow >= totalItems
            ? "opacity-40 cursor-not-allowed"
            : ""
            }`}
        >
          ❯
        </button>
      </div>
    );
  };

  return (
    <Suspense fallback={<></>}>
      <div className="relative max-w-lg">
        <Carousel
          responsive={responsive}
          swipeable
          draggable
          arrows={false}
          customButtonGroup={<ButtonGroup />}
          renderButtonGroupOutside={true}
          showDots={true}
          renderDotsOutside={true}
          ssr={true}
          infinite={false}
          autoPlay={true}
          autoPlaySpeed={4000}
          dotListClass=""
          keyBoardControl={true}
          rewind
          containerClass="carousel-container"
          itemClass="carousel-item"
          rewindWithAnimation={false}
        >
          {images?.map((d, idx) => (
            <div
              key={idx}
              className="w-full h-[450px] flex flex-col gap-4 bg-gray-50 dark:bg-gray-800 rounded-lg p-4 "
            >
              <img src={d} alt={`slide-${idx}`} className="w-full h-full object-contain" />
            </div>
          ))}
        </Carousel>
      </div>
    </Suspense>
  );
};

export default ImageSliders;








